const EVENT_TYPE = "dashboard.component.show";
export default {
  type: EVENT_TYPE,
  getJs: () => `
    case '${EVENT_TYPE}':
      var $comp = $('#' + data.componentId);
      if ($comp) {
          $comp.show();
      }
      break;\n
  `,
};
